import { enableAuthStage, getDomainIdentity, getDomainIdentityRejected, getDomainIdentityResolved, resetDomainIdentity, } from '@innovyze/stylovyze/lib/actions/login.actions';
import { createReducer } from '@reduxjs/toolkit';
import { LOGIN_STATUS_ENUM, } from '@innovyze/stylovyze/lib/types/login.types';
export const initialState = {
    status: LOGIN_STATUS_ENUM.IDLE,
};
const reducer = {
    [getDomainIdentity.toString()]: () => {
        return { status: LOGIN_STATUS_ENUM.PENDING };
    },
    [getDomainIdentityResolved.toString()]: (_state, action) => ({
        provider: action.payload,
        status: LOGIN_STATUS_ENUM.SUCCESS,
    }),
    [getDomainIdentityRejected.toString()]: () => ({
        status: LOGIN_STATUS_ENUM.ERROR,
    }),
    [resetDomainIdentity.toString()]: () => {
        return {
            status: LOGIN_STATUS_ENUM.IDLE,
        };
    },
    [enableAuthStage.toString()]: state => ({
        ...state,
        status: LOGIN_STATUS_ENUM.AUTH_STAGE,
    }),
};
export default createReducer(initialState, reducer);
